module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_1.45dbf544.ttf";